"use client";

import Image from "next/image";
import React, { ReactNode } from "react";
const StatsCard3 = ({
  title,
  subtitle,
  icon,
  gridStyle,
  logos,
  studentImages
}: {
  title: string;
  subtitle: string;
  icon: ReactNode;
  gridStyle: {
    gridRow: string;
    gridColumn: string;
  };
  logos: {
    image: string;
  }[];
  studentImages: string[];
}) => {
  const totalLength = studentImages.length;
  const partSize = Math.floor(totalLength / 3);
  const remainder = totalLength % 3;
  const part1 = studentImages.slice(0, partSize + (remainder > 0 ? 1 : 0));
  const part2 = studentImages.slice(part1.length, part1.length + partSize + (remainder > 1 ? 1 : 0));
  const part3 = studentImages.slice(part1.length + part2.length);
  const dividedArrays = [part1, part2, part3];
  return <div className="stats-section-card--3" style={gridStyle} data-sentry-component="StatsCard3" data-sentry-source-file="StatsCard3.tsx">
      <div className="stats-section-card--3--left">
        <div className="stats-section-card--title">
          {title}
        </div>
        <div className="stats-section-card--subtitle">
          {subtitle}
        </div>
      </div>

      <div className="stats-section-card--3--right">
        <div className="stats-section-card--3--marquee">
          <div className="logos marquee-up">
            {dividedArrays[0]?.map((image, index) => <Image key={index} className="image" src={image} alt={"student-image"} width={129.84} height={64.97} loading='lazy' />)}
          </div>
          <div className="logos marquee-up">
            {dividedArrays[0]?.map((image, index) => <Image key={index} className="image" src={image} alt={"student-image"} width={129.84} height={64.97} loading='lazy' />)}
          </div>
        </div>
        <div className="stats-section-card--3--marquee">
          <div className="logos marquee-down">
            {dividedArrays[1].map((image, index) => <Image key={index} className="image" src={image} alt={"student-image"} width={129.84} height={64.97} loading='lazy' />)}
          </div>
          <div className="logos marquee-down">
            {dividedArrays[1].map((image, index) => <Image key={index} className="image" src={image} alt={"student-image"} width={129.84} height={64.97} loading='lazy' />)}
          </div>
        </div>
        <div className="stats-section-card--3--marquee">
          <div className="logos marquee-up">
            {dividedArrays[2].map((image, index) => <Image key={index} className="image" src={image} alt={"student-image"} width={129.84} height={64.97} loading='lazy' />)}
          </div>
          <div className="logos marquee-up">
            {dividedArrays[2].map((image, index) => <Image key={index} className="image" src={image} alt={"student-image"} width={129.84} height={64.97} loading='lazy' />)}
          </div>
        </div>
      </div>
    </div>;
};
export default StatsCard3;